<section id="content-routine" *ngIf="!isOpened">
  <div class="row container-style">
    <form class="needs-validation " novalidate [formGroup]="formMaintenanceRoutine">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="delete()"></app-custom-button>

            <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
              (onClick)="printPage()"></app-custom-button>

            <app-custom-button [label]="'Equipos'" [severity]="'success'" [variant]="undefined" [icon]="'pi pi-plus'"
              [width]="'5.5rem'" (onClick)="openArticleSelectionModal()"></app-custom-button>
            <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Equipos'"
              [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
              (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="maintenanceRoutineContract.userNameCreate"
              [createDate]="maintenanceRoutineContract.createDate"
              [userNameUpdate]="maintenanceRoutineContract.userNameUpdate"
              [updateDate]="maintenanceRoutineContract.updateDate"
              [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-12 d-flex align-items-center gap-4 mb-2"
          [ngClass]="this.maintenanceRoutineId == 0 ? 'text-danger': ''">
          <div>
            <label class="text-muted small d-block">Equipo</label>
            <span class="fw-bold">
              {{articleObject.code == 0 ? '' : articleObject.code }}
            </span>
          </div>
          <div>
            <label class="text-muted small d-block">Cód. Alt.</label>
            <span class="fw-bold">
              {{articleObject.alterCode}}
            </span>
          </div>
          <div>
            <label class="text-muted small d-block">Nombre</label>
            <span class="fw-bold text-uppercase">
              {{articleObject.name}}
            </span>
          </div>
        </div>
        <div class="col-lg-6 col-12 d-flex align-items-center justify-content-lg-end justify-content-start gap-2">
          <app-custom-tag [visibleLabel]="false" [severity]="severityState" [value]="stateText"></app-custom-tag>
          <app-custom-button [title]="titleState" [icon]="iconState" (onClick)="changeState()"></app-custom-button>

          <app-custom-button [title]="'Copiar'" [label]="'Copiar Rutina'" [width]="'7.5rem'" [icon]="'pi pi-copy'"
            [severity]="'contrast'" [disabled]="maintenanceRoutineContract.active"
            (onClick)="openCopyMaintenanceRoutine()"></app-custom-button>
          <app-custom-modal #copyModal [label]="'Copiar Rutina de Mantenimiento'" [width]="'35rem'"
            [header]="'Copiar Rutina de Mantenimiento'" [children]="componentCopyMaintenanceRoutine"
            [inputs$]="inputsForCopy$" [output$]="output$" hidden>
          </app-custom-modal>

          <app-custom-button [title]="'Insumos'" [label]="'Insumos'" [width]="'7.5'" [icon]="'pi pi-box'"
            [severity]="'contrast'" (onClick)="openSuppliesModal()"></app-custom-button>

          <app-custom-modal #suppliesModal [label]="'Insumos Rutina'" [width]="'88rem'" [header]="'Insumos Rutina'"
            [children]="suppliesRoutineComponent" [inputs$]="inputsForSupplies$" [output$]="output$" hidden>
          </app-custom-modal>

          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="disabledForm" [variant]="undefined"
            (onClick)="send()"></app-custom-button>
        </div>
      </div>

    </form>
  </div>
  <div class="row mt-2">
    <div class="col-md-3">
      <div class=" container-style p-0 mb-3">
        <app-component [maintenanceRoutineModel]="maintenanceRoutineContract"
          [permissionUpdatable]="permissionUpdatable" (emitSelectedComponent)="changeComponent($event)"
          (quantityComponents)="quantityComponents=$event"></app-component>
      </div>
      <div class="container-style p-0 pb-3 pt-0">
        <app-element [componentModel]="selectedComponent" [permissionUpdatable]="permissionUpdatable"
          [active]="maintenanceRoutineContract.active" (emitSelectedElement)="selectedElement=$event"></app-element>
      </div>
    </div>
    <div class="col-md-9">
      <div class="container-style px-0 pb-2 pt-0">
        <app-maintenance-routine-detail [elementModel]="selectedElement" [disabledForm]="disabledForm"
          [active]="maintenanceRoutineContract.active"
          [permissionUpdatable]="permissionUpdatable"></app-maintenance-routine-detail>
      </div>
    </div>
  </div>
</section>

<!-- Impresión -->
<app-print-maintenance-routine id="print-maintenance-routine" [companyId]="companyId" [formatModel]="formatModel"
  [maintenanceRoutinePrintContract]="maintenanceRoutinePrintContract" [editFormat]="false" [focusText]="false"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-maintenance-routine>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>